unit App.Types;

interface

type
  TProc = reference to procedure;

  TOnLineEvent = procedure(IsConnected: boolean) of object;

  TSuccessProc = reference to procedure;
  TLogoutProc = reference to procedure(AMessage: string = '');
  TUnauthorizedAccessProc = reference to procedure(AMessage: string);

  TListProc = reference to procedure;
  TEditProc = reference to procedure(AId: JSValue);

implementation


end.
